import * as yup from "yup";

export const adminSignInSchema = yup.object().shape({
  email: yup.string().email("This shows when you input an invalid email address").required("The field is required."),
  password: yup.string().required("The field is required."),
});
